export { CollectionLocation } from './lib/collection-location'
export { getStaticPaths } from './lib/get-static-paths'
export { getStaticProps } from './lib/get-static-props'
export type { CollectionLocationProps } from './lib/get-static-props'
